import * as React from 'react';

import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Paper from "@mui/material/Paper"
import SignatureCanvas from 'react-signature-canvas'
import Table from '@mui/material/Table'
import TableHead from '@mui/material/TableHead'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Typography from '@mui/material/Typography'



export default function CharismaTutorDocsToAcceptForm(props){
    
   
    const [validatedDocs, setValidatedDocs] = React.useState([]);
    const [sigEmpty, setSigEmpty] = React.useState(true);
    
    let sigCanvas = React.useRef(null);


    function handleAccept(pEvent : React.ChangeEvent<HTMLInputElement>, pId : number){
        let lNewSelected : number[] = [];
        let lIndex = validatedDocs.indexOf(pId);
        if(pEvent.target.checked && lIndex === -1){
            lNewSelected = lNewSelected.concat(validatedDocs, pId);
        }
        else if(lIndex !== -1){
            if(lIndex === 0){
                lNewSelected = lNewSelected.concat(validatedDocs.slice(1));
            }
            else if(lIndex === validatedDocs.length - 1){
                lNewSelected = lNewSelected.concat(validatedDocs.slice(0, -1));
            }
            else{
                lNewSelected = lNewSelected.concat(validatedDocs.slice(0, lIndex), validatedDocs.slice(lIndex + 1),);
            }
        }
        setValidatedDocs(lNewSelected);        
    }
    
    function handleSubmit(){
        const signature = props.signature ? sigCanvas.getTrimmedCanvas().toDataURL('image/png') : null
        props.handleSubmit(signature);
    }
    
    function handleClear(){
        sigCanvas.clear();
        setSigEmpty(true);
    }    
    
    function createSignature(){
        return(
            <div>
            <Paper
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'left', 
                alignItems: 'left',
                p: 2 
            }} 
                elevation={3}
            >
            <Typography>Signature</Typography>
            <SignatureCanvas 
                ref={(ref) => { sigCanvas = ref }}
                onEmpty={()=>setSigEmpty(true)} 
                onEnd={()=>setSigEmpty(false)} 
                penColor='black'
                canvasProps={{width: 450, height: 150, className: 'sigCanvas'}} 
            />
            <Button onClick={()=>handleClear()}>Effacer</Button>
       
            </Paper>
            <Typography>La signature est conservée sur la plateforme Charisma et est utilisée pour apposée votre signature aux documents suivants</Typography>
            <List sx={{ listStyleType: 'disc', marginLeft:'40px' }}>
                    <ListItemText sx={{ display: 'list-item' }}>Bilans Mensuels</ListItemText>
                    <ListItemText sx={{ display: 'list-item' }}>Evaluations</ListItemText>
                    <ListItemText sx={{ display: 'list-item' }}>Visites Tuteurs</ListItemText>
                    <ListItemText sx={{ display: 'list-item' }}>Visites de régulations</ListItemText>
            </List>     
            </div>
        )
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                Documents à lire et accepter
            </DialogTitle>
            <DialogContent>
                <Typography>
                Vous êtes tuteur de {props.student} pour la formation {props.training}. A ce titre vous êtes tenus de lire et accepter les documents suivants:
                </Typography>
                <Table>
                    <TableHead>
                        <TableRow key="title">
                            <TableCell>
                                Documents
                            </TableCell>
                            <TableCell padding="checkbox">
                                Accepté
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.docs.map((lDoc)=>(
                            <TableRow>
                                <TableCell>
                                    <Link to={lDoc.url} target="_blank" rel="noopener noreferrer" >
                                        {lDoc.name}
                                    </Link>
                                </TableCell>
                                <TableCell>
                                    <Checkbox
                                        checked={validatedDocs.indexOf(lDoc.id) !== -1}
                                        onChange={(event)=>handleAccept(event, lDoc.id)}
                                    />
                                </TableCell>
                            </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
                {props.signature ?
                    createSignature()
                    :
                    
                   null
                    
                }     
                
            </DialogContent>
            <DialogActions>
                <Button disabled={validatedDocs.length !== props.docs.length || (props.signature ? sigEmpty : false)} onClick={()=>handleSubmit()}>OK</Button>
            </DialogActions>
        </Dialog>        
    );
}